module.exports = __webpack_public_path__ + "static/apple-icon-180x180-9e69be0302bd2f1cbbd53aeffe6b0e2b.png";